import React from 'react';
import { AuthLayout } from '../../components/AuthUI';

const AuthPage: React.FC = () => {
  return <AuthLayout />;
};

export default AuthPage;
